<template>
  <section class="d-flex">
    <div class="video-section">
      <div>
        <span
          v-text="section.heading"
          name="heading"
          class="heading"
          @blur="updateSection"
          :contenteditable="editableText"
        ></span>
      </div>

      <div>
        <span
          class="url"
          v-text="urlText"
          name="url"
          @blur="updateSection"
          :contenteditable="editableText"
        ></span>
      </div>

      <div v-if="section.url" class="preview-img position-relative" @click="openVideo">
        <b-img alt="video preview" :src="previewUrl"></b-img>
        <!-- <b-icon-play-fill /> -->
      </div>
    </div>
    <div class="d-flex align-itens-center">
      <SectionControls
        class="mt-1"
        :case-study-id="caseStudyId"
        :index="index"
        v-if="editable && !isIntroduction"
      />
    </div>
  </section>
</template>
<script>
import { getPreviewUrl } from '@lib/video_urls'
import SectionMixin from '@app/mixins/case_study_section'
import SectionControls from '@components/case_study_sections/SectionControls.vue'

export default {
  name: 'VideoSection',
  components: { SectionControls },
  mixins: [SectionMixin],
  props: {
    caseStudyId: { type: Number, required: true },
    section: { type: Object, required: true },
    index: { type: Number, required: true },
    editable: { type: Boolean, required: false, default: false },
    isIntroduction: { type: Boolean, required: false, default: false },
  },
  computed: {
    urlText() {
      return this.section.url || 'Enter youtube or vimeo url'
    },
    editableText() {
      // In Vue 3 you have to use null/undefined to make an attribute conditionally
      // not render, false won't work
      return this.editable ? true : null
    },
    previewUrl() {
      return getPreviewUrl(this.section.url)
    },
  },
  methods: {
    openVideo() {
      window.open(this.section.url, '_blank')
    },
  },
}
</script>

<style lang="sass" scoped>

.video-section
  width: 100%

.delete
  cursor: pointer

.preview-img
  cursor: pointer
  justify-content: center
  align-items: center

.preview-img img
  width: 480px
  height: auto

.preview-img .b-icon
  color: white
  width: 120px
  height: 120px
  top: 50%
  left: 50%
  position: absolute
  transform: translate(-50%, -50%)

.heading
  padding: 4px
  font-size: 24px
  font-weight: bold

.url
  padding: 4px
</style>
